/**
 * @Author: DJ
 * @Date:   2021-09-01 16:04:31
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-02 11:01:51
 */
import { createModel } from '@/store/tools';

const model = {
    namespace: 'microbusinesses',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getMemberList': T('getMemberList'),
            'getMemberDetail': T('getMemberDetail'),
            'getRecommentType': T('getRecommentType'),
            'getRecommentList': T('getRecommentList'),
            'getScoreList': T('getScoreList'),
            'getMemberState': T('getMemberState'),

            'getCompanyList': T('getCompanyList'),
            'getCompanyDetail': T('getCompanyDetail'),
            'getCompanyAccount': T('getCompanyAccount'),
            'getCompanyAccountStatus': T('getCompanyAccountStatus'),
            'getTemplateList': T('getTemplateList'),

            'getCouponList': T('getCouponList'),
            'getCouponTypeList': T('getCouponTypeList'),
        },
        actions: {
            'getMemberList': A('getMemberList'),
            'getMemberDetail': A('getMemberDetail'),
            'getRecommentType': A('getRecommentType', { enumName: 'UserReferrerTypeEnum' }),
            'getRecommentList': A('getRecommentList'),
            'getScoreList': A('getScoreList'),
            'getMemberState': A('getMemberState', { enumName: 'UserStatusEnum' }),

            'getCompanyList': A('getCompanyList'),
            'getCompanyDetail': A('getCompanyDetail'),
            'getCompanyAccount': A('getCompanyAccount'),
            'getCompanyAccountStatus': A('getCompanyAccountStatus'),
            'getTemplateList': A('getTemplateList'),

            'getCouponList': A('getCouponList'),
            'getCouponTypeList': A('getCouponTypeList'),
        },
        sagas: {
            'getMemberList': S('getMemberList', '/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.list'),
            'getMemberDetail': S('getMemberDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.getUserBrokerInfo'),
            'getRecommentType': S('getRecommentType', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRecommentList': S('getRecommentList', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.listUserReferrer'),
            'getScoreList': S('getScoreList', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.totalBalanceList'),
            'getMemberState': S('getMemberState', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),

            'getCompanyList': S('getCompanyList', '/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.list'),
            'getCompanyDetail': S('getCompanyDetail', '/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.detail'),
            'getCompanyAccount': S('getCompanyAccount', '/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.listEnterpriseChildInfo'),
            'getCompanyAccountStatus': S('getCompanyAccountStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTemplateList': S('getTemplateList', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.enterpriseList'),

            'getCouponList': S('getCouponList', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.listCoupon'),
            'getCouponTypeList': S('getCouponTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),

        },
        reducers: {
            'getMemberList': R('getMemberList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getMemberDetail': R('getMemberDetail', {}),
            'getRecommentType': R('getRecommentType', []),
            'getRecommentList': R('getRecommentList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getScoreList': R('getScoreList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getMemberState': R('getMemberState', []),

            'getCompanyList': R('getCompanyList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCompanyDetail': R('getCompanyDetail', {}),
            'getCompanyAccount': R('getCompanyAccount', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCompanyAccountStatus': R('getCompanyAccountStatus', []),
            'getTemplateList': R('getTemplateList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),

            'getCouponList': R('getCouponList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCouponTypeList': R('getCouponTypeList', []),

        }
    })
};
export default createModel(model);